import React, 
       { useState, 
         useContext, 
         useEffect }   from 'react';
import { Card, 
         Form, 
         Button, 
         Container, 
         Row, 
         Col         } from 'react-bootstrap';
import api             from './AxiosConfig';
import { AuthContext } from './AuthContext';

function AdminOptions() {
    const { isLoggedIn,
            isAdmin     }                     = useContext(AuthContext);
    const [message,        setMessage]        = useState('');
    const [messageError,   setMessageError]   = useState( false );
    const [adminOptions,   setAdminOptions]   = useState( [] );
    const [newAdminOption, setNewAdminOption] = useState( { key: "", value: "" } );
    const [newOptionAdded, setNewOptionAdded] = useState( true );
       
    useEffect(() => {
        // Fetch status and admin options only once on mount
        async function getAdminOpts() {
            try {
                if ( isLoggedIn && isAdmin && newOptionAdded) {
                    const response = await api.get('/site/admin-options', {withCredentials: true });
                    if (response.status === 201) {
                        setAdminOptions(response.data.adminOptions);
                    }
                    setNewOptionAdded( false );
                }
            } catch (error) {
                console.log("Error " + error);
            }
        }

        getAdminOpts();
    }, [newOptionAdded, isLoggedIn, isAdmin]);

    const handleChange = (i, event) => {
        const name  = event.target.name;
        const value = event.target.value;
        console.log("handleChange(" + i + ") " + name + " = " + value);
        setAdminOptions( prevValues => {
            const updated = [...prevValues];
            updated[i] = { key: name, value: value};
            return updated;
            });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
           const response = await api.put(`/site/admin-options`, { adminOptions: adminOptions } , { withCredentials: true });
           setMessage(response.data.message);  // Display success message from server
           setMessageError( false );
        } catch (error) {
           if (error.response) {
              setMessage(error.response.data.message);  // Display error message from server
              setMessageError( true );
           } else {
              setMessage('An error occurred while updating.');
              setMessageError( true );
           }
        }
    };

    const updateNewAOKey = ( event ) => {
       setNewAdminOption( { key: event.target.value, value: newAdminOption.value } );
    }
    const updateNewAOValue = ( event ) => {
       setNewAdminOption( {  key: newAdminOption.key, value: event.target.value } );
    }

    const handleAddAOItem = async (e) => {
        e.preventDefault();
        try {
           const response = await api.put(`/site/admin-options/new`, { newAdminOption: newAdminOption } , { withCredentials: true });
           setMessage(response.data.message);  // Display success message from server
           setMessageError( false );
           setNewOptionAdded( true );
        } catch (error) {
           if (error.response) {
              setMessage(error.response.data.message);  // Display error message from server
              setMessageError( true );
           } else {
              setMessage('An error occurred while updating.');
              setMessageError( true );
           }
        }
    }
       
    return (
 isAdmin ? (
      <Card>
      <Card.Header className="card-goal-header">
        <Card.Title>
          <div className="content-container">
            <div className="left-content d-flex align-items-center">
              Admin
            </div>
            <div className="right-content">
               <></>
            </div>
          </div>
        </Card.Title>
        <Card.Subtitle className="text-center">Admin Options</Card.Subtitle>
      </Card.Header>
      <Card.Body className="p-0" >
        <Container className="mt-4">
                    <Form onSubmit={handleSubmit}>
                        {  adminOptions.map( ( ao, i ) => (
                        <Form.Group as={Row} className="mb-3" controlId={ao.key}>
                            <Form.Label column className="text-end">{ao.key}</Form.Label>
                            <Col>
                                <Form.Control
                                type="text"
                                name={ao.key}
                                value={ao.value}
                                onChange={(e) => handleChange( i, e )}
                            />
                            </Col>
                        </Form.Group>

                               
                        ))}    

                        {/* Submit Button */}
                        <Form.Group as={Row} className=" text-center mt-4">
                        <Col>
                        <Button variant="primary" type="submit">
                            Update Admin Options
                        </Button>
                        </Col>
                        </Form.Group>
                                    
                    </Form>
                    <div className={"card-goal-seperator"}>Add New Option</div>   
                    <Form>
                      <div className="content-container">
                        <div className={"left-content d-flex align-items-center flex-grow-1"} style={{ minWidth: 0 }}>
                          <Form.Control type="text" className={"w-100 flex-grow-1"} value={newAdminOption.key} name="newKey" onChange={e => updateNewAOKey( e )} />
                        </div>
                        <div className={"right-content d-flex align-items-center"}>
                          <Form.Control type="text" value={newAdminOption.value} name="Value" onChange={e=> updateNewAOValue( e )} />    
                          <Button variant="primary" size="sm" onClick={handleAddAOItem}>+</Button>
                        </div>
                      </div>
                    </Form> 
                               
                    <Row><Col className={'text-center message-err-' + messageError }>{message}</Col></Row>
        </Container>
        </Card.Body>
      </Card> ) : (
          <div>Only avaiable to Admin Users</div>
      ) 
    );
}

export default AdminOptions;
